import { BaseResponse } from './_base';

export interface GetPropertyOwnerResponseTO {
  propertyOwnership: {
    propertyUid: string;
    owner: PropertyOwner | null;
    ownerNotes: string | null;
    copyOwnerWhenBookingConfirmed: boolean;
    collectAndRemitTaxes: boolean;
  };
}

export interface GetAgencyOwnersResponseTO extends BaseResponse {
  owners: AgencyOwner[];
}

export enum PropertyOwnerPermissionType {
  READING_CALENDAR = 'READING_CALENDAR',
  READING_BOOKING_DETAILS = 'READING_BOOKING_DETAILS',
  READING_BOOKING_VALUE = 'READING_BOOKING_VALUE',
  CREATING_BLOCKS = 'CREATING_BLOCKS',
  VIEW_ANALYTICS = 'VIEW_ANALYTICS',
}

export enum OwnerFormula {
  DEFAULT = 'DEFAULT',
  RENTAL_REVENUE = 'RENTAL_REVENUE',
  RENTAL_REVENUE_AND_CLEANING_FEE = 'RENTAL_REVENUE_AND_CLEANING_FEE',
  RENTAL_REVENUE_MINUS_AGENCY_COMMISSION = 'RENTAL_REVENUE_MINUS_AGENCY_COMMISSION',
}

export interface AgencyOwner {
  agencyCommissionRate: number | null;
  airbnbUserId: number | null;
  businessName: string | null;
  ccEmails: string | null;
  collectAndRemitTaxes: boolean;
  copyOwnerWhenBookingConfirmed: boolean;
  country: string | null;
  email: string;
  externalCalendarUrl: string | null;
  firstName: string | null;
  isActive: boolean | null;
  lastName: string | null;
  permissionTypes: PropertyOwnerPermissionType[] | null;
  phoneNumber: string | null;
  phoneNumberAreaCode: number | null;
  pictureUrl: string | null;
  preferredLocale: string | null;
  uid: string;
  website: string | null;
  formula: OwnerFormula | null | undefined;
}

export interface PropertyOwner
  extends Omit<
    AgencyOwner,
    | 'airbnbUserId'
    | 'calendarUrl'
    | 'collectAndRemitTaxes'
    | 'copyOwnerWhenBookingConfirmed'
    | 'country'
    | 'externalCalendarUrl'
    | 'isActive'
    | 'website'
  > {
  lastLoginUtcDateTime: string | null;
  invitationSent: boolean;
}

export interface GetSendOwnerInviteTemplateResponseTO {
  bcc: boolean;
  content: string;
  file: string;
  isCustom: boolean;
  language: string;
  masterID: number;
  subject: string;
  test: number;
  to: string;
}
